<h2>You're in Spectator mode!</h2>
<p class="text-base">Stay on the sidelines or join a team to be part of the game!</p>

<div class="hrz-end gap-1">
    <button mat-flat-button  class="text-button" (click)="justWatch()">Continue Watching</button>
    <button mat-button (click)="joinTeam()" class="flat-button">Join a Team</button>
</div>